import { useState } from "react";
import logo from "./../../assets/cubes_with_background.png";
import SignUpModal from "../authentication/SignUpModal";
import LogInModal from "../authentication/LogInModal";
import { useAuth } from "../authentication/AuthContext";
import { logAnalyticsEvent } from "../engagement/Amplitude";
import UserAvatar from "./UserAvatar";
import { PiArrowClockwiseDuotone } from "react-icons/pi";

export default function ChatHeader({ onRefresh }: { onRefresh: () => void }) {
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const { user } = useAuth();

  return (
    <div>
      <div
        className="flex p-4 md:p-8 items-center h-12 md:h-16 
      bg-gradient-to-b to-base-100/0 from-base-300"
      >
        <a
          className="btn btn-ghost text-xl px-0 mr-2"
          href="/"
        >
          <div className="flex items-center gap-2 sm:gap-4">
            <img
              src={logo}
              alt="logo"
              className="rounded-lg w-8 md:w-10"
            />
          </div>
        </a>
        <div
          className="tooltip tooltip-bottom"
          data-tip="Clear Chat"
        >
          <PiArrowClockwiseDuotone
            size={14}
            className="w-8 h-8 hover:105 cursor-pointer btn btn-circle btn-ghost "
            onClick={onRefresh}
          />
        </div>
        <div className="grow"></div>
        {user ? (
          <UserAvatar />
        ) : (
          <div>
            <div className="max-sm:hidden">
              <button
                className="btn btn-outline btn-sm md:btn-md mr-4"
                onClick={() => {
                  logAnalyticsEvent("Press Log In");
                  setIsLoginOpen(true);
                }}
              >
                Log in
              </button>
              <button
                className="btn btn-primary btn-sm md:btn-md"
                onClick={() => {
                  logAnalyticsEvent("Press Sign Up");
                  setIsSignUpOpen(true);
                }}
              >
                Sign up
              </button>
            </div>
            <details className="dropdown dropdown-end sm:hidden">
              <summary className="m-1 btn">Log In</summary>
              <ul className="p-2 shadow menu dropdown-content z-[1] bg-base-300 rounded-box w-52">
                <li>
                  <a
                    onClick={() => {
                      logAnalyticsEvent("Press Log In");
                      setIsLoginOpen(true);
                    }}
                  >
                    Log In
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      logAnalyticsEvent("Press Sign Up");
                      setIsSignUpOpen(true);
                    }}
                  >
                    Sign Up
                  </a>
                </li>
              </ul>
            </details>
          </div>
        )}
      </div>
      <SignUpModal
        isOpen={isSignUpOpen}
        onClose={() => setIsSignUpOpen(false)}
      />
      <LogInModal
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
      />
    </div>
  );
}
